import React, { useMemo } from 'react';
import { Select } from 'antd';
import PropTypes from 'prop-types';
import WorkflowConfigureMultipleSourceSelector from './WorkflowConfigureMultipleSourceSelector';
import {
  getFieldSelectOptions,
  SOURCE_SELECTOR_MAX_WIDTH,
} from './selectorHelpers';

export default function WorkflowConfigureSourceSelector({
  fieldMappings,
  defaultValue,
  value,
  onFieldMappingsChange,
  targetId,
  eligibleSourceFields = [],
  formId,
  maxWidth = SOURCE_SELECTOR_MAX_WIDTH,
  allowMultipleStaticText = false,
}) {
  const sourceFieldMap = useMemo(() => {
    const map = {};
    eligibleSourceFields.forEach((field) => {
      map[field.id] = field;
    });

    return map;
  }, [eligibleSourceFields]);

  if (allowMultipleStaticText) {
    return (
      <WorkflowConfigureMultipleSourceSelector
        fieldMappings={fieldMappings}
        defaultValue={defaultValue}
        onFieldMappingsChange={onFieldMappingsChange}
        targetId={targetId}
        eligibleSourceFields={eligibleSourceFields}
        formId={formId}
        maxWidth={maxWidth}
      />
    );
  }

  return (
    <Select
      placeholder="Select source field"
      dropdownMatchSelectWidth={false}
      style={{ width: '100%', maxWidth }}
      className={{ 'select-warning': !!sourceFieldMap[value]?.displayWarning }}
      allowClear
      defaultValue={defaultValue}
      value={value}
      onChange={(sourceId) => {
        const newData = {
          ...fieldMappings,
        };

        if (sourceId) {
          newData[targetId] = sourceId;
        } else {
          delete newData[targetId];
        }

        onFieldMappingsChange(newData, formId);
      }}
    >
      {
        getFieldSelectOptions(eligibleSourceFields)
      }
    </Select>
  );
}

WorkflowConfigureSourceSelector.propTypes = {
  fieldMappings: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  defaultValue: PropTypes.string,
  value: PropTypes.string.isRequired,
  onFieldMappingsChange: PropTypes.func.isRequired,
  targetId: PropTypes.string.isRequired,
  formId: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  eligibleSourceFields: PropTypes.arrayOf(PropTypes.object).isRequired,
  maxWidth: PropTypes.number,
  allowMultipleStaticText: PropTypes.bool,
};

WorkflowConfigureSourceSelector.defaultProps = {
  defaultValue: null,
  maxWidth: SOURCE_SELECTOR_MAX_WIDTH,
  allowMultipleStaticText: false,
  formId: undefined,
};
